import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import pt from "vuetify/src/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { pt },
    current: "pt"
  },
  icons: {
    iconfont: "fa"
  },
  theme: {
    themes: {
      light: {
        primary: "#132237",
        secondary: "#60BA8E",
        accent: "#005377",
        error: "#B80C09",
        info: "#5CCEFF",
        success: "#5EB98F",
        warning: "#ECD444"
      },
      dark: {
        primary: "#132237",
        secondary: "#60BA8E",
        accent: "#005377",
        error: "#B80C09",
        info: "#5CCEFF",
        success: "#5EB98F",
        warning: "#ECD444"
      }
    }
  }
});
